/**
 * [normalizeValue] removes special characters and replaces "spacing" characters (`_`, `-`) with whitespace
 * Context: BE normalizes values, so in order to get the same values, we need to apply the same logic
 * @param value: string
 */

export const normalizeValue = (value) => {
  if (!value || typeof value !== 'string') {
    return;
  }
  // replace accented characters with simple characters
  // https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
  const removedAccents = value.normalize('NFD').replace(/[\u0300-\u036F]/g, '');
  // remove special characters except `-` and `_`
  const removedSpecialCharacters = removedAccents.replace(/[^\s\w-]+/g, '');
  // replace `-` and `_` with whitespace
  return removedSpecialCharacters.replace(/-/g, ' ').replace(/_/g, ' ').trim();
};

export const cleanUrls = (url) => {
  return (
    url
      .toLowerCase() // 1. Lowercase
      .normalize('NFD') // 2. Normalize accents
      // eslint-disable-next-line unicorn/escape-case
      .replace(/[\u0300-\u036f]/g, '') // Remove diacritics
      // eslint-disable-next-line unicorn/better-regex
      .replace(/[^\w\s-]/g, '') // 3. Remove other special characters if needed
      .replace(/\s+/g, ' ') // Clean up extra spaces
      .trim()
  );
};
